import React, { useEffect } from 'react';

import 'react-contexify/dist/ReactContexify.min.css';
import HTML5Backend from 'react-dnd-html5-backend';
import { DragDropContext } from 'react-dnd';
import { connect } from 'react-redux';
import { MenuProvider, Menu } from 'react-contexify';

import { getStore } from '../../../state/store';

import Console from '../../../lib/debug';
import Week from './Week';
import CalendarContextMenu from './CalendarContextMenu';

import SegmentService, {
    EVENTS as SEGMENT_EVENTS
} from '../../../lib/segment/SegmentService';

const CalendarMonth = props => {
    Console.render('CalendarMonth');

    useEffect(
        () => {
            if (!props.nutrition) {
                return;
            }
            const nutritionCardCount = Object.entries(props.nutrition).filter(
                day => isNutritionForMonth(day[0], props.year, props.month)
            ).length;

            if (
                props.athleteId &&
                !props.nutritionLoading &&
                nutritionCardCount > 0
            ) {
                SegmentService.trackToApi(SEGMENT_EVENTS.FeatureViewed.key, {
                    feature: 'Nutrition - Web Card Viewed',
                    location: 'Coach Web Calendar',
                    details: [
                        {
                            athleteId: props.athleteId
                        },
                        {
                            monthViewed: `${props.month}/${props.year}`
                        },
                        {
                            numberOfDaysWithNutrition: nutritionCardCount
                        }
                    ]
                });
            }
        },
        [
            props.athleteId,
            props.year,
            props.month,
            props.nutrition,
            props.nutritionLoading
        ]
    );

    let numWeeks = props.dayList.length / 7;
    let weeks = [];
    for (let i = 0; i < numWeeks; i++) {
        weeks.push(<Week key={'w' + i} num={i} />);
    }

    if (props.dayList.length % 7 > 0) {
        let i = props.dayList.length / 7 + 1;
        weeks.push(<Week key={'w' + i} num={i + 1} />);
    }

    let className = 'r-calendar';

    return (
        <div className={className}>
            <MenuProvider id="calendar-context-menu">{weeks}</MenuProvider>
            <Menu className="th-menu" id="calendar-context-menu">
                <CalendarContextMenu store={getStore()} />
            </Menu>
        </div>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        dayList: state.calendar.dayList,
        nutrition: state.calendar.nutrition ? state.calendar.nutrition : null,
        athleteId: state.calendar.infoTree.athleteId,
        month: state.calendar.infoTree.month,
        year: state.calendar.infoTree.year,
        nutritionLoading:
            state.calendar.uiTree && state.calendar.uiTree.nutritionLoading
    };
};

const isNutritionForMonth = (dayKey, currentYear, currentMonth) => {
    const keyYear = dayKey.split('_')[0];
    const keyMonth = dayKey.split('_')[1];
    return keyYear == currentYear && keyMonth == currentMonth;
};

const CalendarMonthConnect = connect(mapStateToProps)(CalendarMonth);

export default DragDropContext(HTML5Backend)(CalendarMonthConnect);



// WEBPACK FOOTER //
// ./src/view/calendar/components/CalendarMonth.jsx